import { ClickAwayListener, Popper as MuiPopper, PopperProps, styled } from '@mui/material';
import { useMemo, MouseEvent, PropsWithChildren, KeyboardEvent } from 'react';

export interface StyledPopperProps extends PopperProps {
  onClose?: (e?: MouseEvent) => void;
  target: string;
  dataId?: string;
}

const Popper = styled(MuiPopper)(({ theme }) => ({
  boxShadow: 'var(--shadow-dropdown)',
  borderRadius: 'var(--border-radius-6)',
  maxWidth: 280,
  zIndex: 'var(--zindex-tooltip-react)',
  border: 'none !important',
  background: 'var(--surface-bg-color)',
  marginTop: theme.spacing(1),
  minWidth: 160,
  backgroundColor: 'var(--surface-bg-color)',
  flexDirection: 'column',
  display: 'flex',
  overflow: 'hidden',
  margin: 0,
  transition: 'none !important',
  transformOrigin: 'unset !important',
  '& .MuiList-root': {
    overflowY: 'auto',
    maxHeight: '300px',
    width: '100%',
    padding: 0
  }
}));

export function StyledPopper({
  open,
  onClose,
  children,
  target,
  dataId = '',
  ...props
}: PropsWithChildren<StyledPopperProps>) {
  const focusTarget = () => {
    const elementId = target?.split('#')[1] || null;

    if (elementId) {
      document.getElementById(elementId)?.focus();
    }
  };

  const handleListKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Tab') {
      if (onClose) {
        onClose();
      }

      focusTarget();
    }
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.stopPropagation();

      if (onClose) {
        onClose();
      }

      focusTarget();
    }
  };

  const anchorEl = useMemo(() => document.querySelector(target), [open, target]);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {anchorEl ? (
        <Popper open={open} anchorEl={anchorEl} {...props}>
          <div className='menu-container' data-id={dataId}>
            <ClickAwayListener
              onClickAway={() => {
                if (onClose) {
                  onClose();
                }
              }}
            >
              {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
              <div onKeyDown={handleListKeyDown}>{children}</div>
            </ClickAwayListener>
          </div>
        </Popper>
      ) : null}
    </>
  );
}
